/** Demo content for the "Setup & Borrower" step. */
export const SetupAndBorrower = () => {
    return <p>Setup and Borrower goes here.</p>;
};
